export const mainColors = {
  darkCyan: '#047fbb',
  green: '#a3c524',
  red: '#e46573'
}